import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';

@Component({
    selector: 'app-loading-popup',
    templateUrl: './loading-popup.component.html',
    styleUrls: ['./loading-popup.component.scss'],
    standalone: true,
    imports: [MatDialogActions]
})
/**
 * A popup that waits on a promise, displaying "Loading..". If the
 * promise resolves, then it closes. Otherwise the error is displayed.
 */
export class LoadingPopupComponent {
    /** stillGoing: whether the popup should still show "Loading..." */
    public stillGoing = true;
    public errormessage: string;

    /**
     * Constructs a new popup based on a given promise.
     */
    constructor(
        private dialogRef: MatDialogRef<LoadingPopupComponent>,
        @Inject(MAT_DIALOG_DATA)
        data: {
            promise: Promise<null>;
            errormessage: string;
        }
    ) {
        data.promise
            .then(() => this.dialogRef.close())
            .catch((error) => {
                this.errormessage = data.errormessage ? data.errormessage : error;
                this.stillGoing = false;
            });
    }

    /**
     * Closes the popup.
     */
    close(): void {
        this.dialogRef.close();
    }
}
